import { uploadPath, languageId, redirectPath } from '@/config'
import { TLoader, TSelect, TRadio, TModal, TTextarea, TButton, TInput, TDatepicker, TCheckbox, TGoogleAutoComplete } from '@/components/common'
import 'devextreme/dist/css/dx.common.css'
import { DxSelectBox } from 'devextreme-vue/select-box'
import SubMenu from '@/components/app/user/partials/navbar/web/subMenu'
import 'vue-select/dist/vue-select.css'
import { mapGetters } from 'vuex'
import { DxDataGrid, DxColumn, DxHeaderFilter, DxSearchPanel, DxFilterRow, DxColumnChooser, DxLoadPanel } from 'devextreme-vue/data-grid'
import { DxTagBox, DxDateBox, DxNumberBox } from 'devextreme-vue'
import buildQuery from 'odata-query'
import DataSource from 'devextreme/data/data_source'
import { DxAutocomplete } from 'devextreme-vue/autocomplete'
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import moment, { duration } from 'moment'

// import { createContext } from 'vm'
// import { isThisSecond } from 'date-fns'

export default {

	name: 'tour-sale-create',
	components: {
		redirectPath, uploadPath, DxSelectBox, TRadio, moment, TLoader, TTextarea, required, requiredIf, TModal, DxTagBox, DxAutocomplete, DxRequiredRule, DxValidator, DxDateBox, DxNumberBox, TCheckbox, SubMenu, TInput, TSelect, TButton, DxDataGrid, DxColumn, DxHeaderFilter, DxSearchPanel, DxFilterRow, DxColumnChooser, DxLoadPanel, TGoogleAutoComplete
	},
	data () {
		return {
			showInfo: false,
			sameAddress: true,
			cities: [],
			gifts: [],
			noBadAgeLimit: null,
			age: null,
			wizardIndex: 0,
			nextPrevious: false,
			customerName: null,
			customerSurname: null,
			lastDiscount: 0,
			seasonId: null,
			tourName: null,
			customerss: [],
			wizard: [
				{ activeconent: true, completeclass: false },
				{ activeconent: false, completeclass: false },
				{ activeconent: false, completeclass: false }
			],
			togetherCustomers: [
				{ name: null, text: 'Özel Talebim Yok', visible: true },
				{ name: 'all', text: 'Hep Birlikte Aynı Odada', visible: false },
				{ name: 'other', text: 'Diğer', visible: true }
			],
			states: [
				{ name: 'Baden-Württemberg', dealerId: 4998221},
				{ name: 'Bayern', dealerId: 4998221},
				{ name: 'Berlin', dealerId: 4998222 },
				{ name: 'Brandenburg', dealerId: 4998222},
				{ name: 'Bremen', dealerId: 4998222},
				{ name: 'Hamburg', dealerId: 4998222},
				{ name: 'Hessen', dealerId: 4998222},
				{ name: 'Mecklenburg-Vorpommern', dealerId: 4998222},
				{ name: 'Niedersachsen', dealerId: 4998222},
				{ name: 'Nordrhein-Westfalen', dealerId: 4998220},
				{ name: 'Rheinland-Pfalz', dealerId: 4998221},
				{ name: 'Saarland', dealerId: 4998221},
				{ name: 'Sachsen', dealerId: 4998222},
				{ name: 'Sachsen-Anhalt', dealerId: 4998222},
				{ name: 'Schleswig-Holstein', dealerId: 4998222},
				{ name: 'Thüringen', dealerId: 4998222}
			],
			isTourHidden: false,
			tourSelectBoxHidden: false,
			displayTourName: false,
			isReadKvkk: false,
			buildingNumber: null,
			neighborhood: null,
			modelData: {
				voucherNo: null,
				description: null,
				totalAmount: null,
				customerCount: null,
				deperatureDate: null,
				companyId: null,
				invoiceCustomer: null,
				accountingDebitCreditId: null,
				mealBoardTypeId: null,
				tourReservationStatusId: 120,
				tourId: null,
				guidePreferId: null,
				isSeminarWants: null,
				seminarLanguageId: null,
				seminarId: null,
				travelGroupCustomers: [{
					roomingDescription: null,
					flightDescription: null,
					customer: { baseAirPort: null, name: '', surname: '', gsm: '', email: '', passportCountryId: null, passportNationalityId: null, '@birthDate': null, birthDate: null, birthPlace: '', passportNumber: '', passportIssueDate: null, passportExpiryDate: null, state: '', city: '' },
					mahramTypeId: null,
					mahram: {},
					'@normalPrice': null,
					'@mahramRequired': true,
					'@mahramTypeRequired': true,
					'@selectedVisaTypes': [],
					'@selectedTourExtras': [],
					'@selectedTourDiscount': [],
					togetherCustomer: { name: null, text: '' },
					// dealerId: null,
					amount: null,
					discount: null,
					tourPricePackage: {},
					tourPricePackageId: null,
					noBed: false,
					customerVisaDocuments: [{ documentName: { id: 1, name: '' }, delivered: false }],
					giftId: null,
					giftIsSent: false,
					specialArea1: null,
					specialArea2: null
				}],
				travelGroupHotelInfos: [{
					isActive: true,
					hotelName: null,
					night: null,
					finishDate: null,
					startDate: null,
					tourHotelItineraryId: null
				}],
				travelGroupFlightInfos: [{
					tourItineraryId: null,
					startDate: null,
					finishDate: null,
					fromAirportId: null,
					fromAirport: {},
					toAirportId: null,
					toAirport: {}
				}]
			},
			selectedTour: { tourTypeId: 159, currency: { symbol: '' } },
			keyIndex: 1,
			mealBoardTypes: [],
			languages: [],
			mahramTypes: [],
			genders: [],
			passportTypes: [],
			countries: [],
			countries2: [],
			airports: [],
			customerTitles: [],
			tourReservationStatuses: [],
			isModalVisible: false,
			uploadPath: uploadPath,
			languageId: languageId,
			redirectPath: redirectPath,
			saasAppDetail: null,
			loaderShow: true,
			loader: {
				color: '#497792',
				size: '30px',
				style: {
					'position': 'inherit',
					'margin': '20% 0px 20% 0px'
				}
			},
			customerDataSource: new DataSource({
				load: async (loadOptions) => {
					try {
						const { data } = await this.$http.get(`Customers/AutoCompleteSearch?search=${loadOptions.searchValue}`)
						return { data: data }
					} catch (error) { }
				}
			})
		}
	},
	mounted () {
		console.log(this.$route)
		if (!this.$route.query.v || this.$route.query.v != '1.05') {
			if (this.$route.fullPath.includes('?')) {
				const params = new URLSearchParams(this.$route.fullPath.replace(this.$route.path, '').replace('?', ''))
				console.log(params.toString())
				params.delete('v')
				console.log(params.toString())
				location.href = (this.$route.path + '?' + params.toString() + '&v=1.05')
			} else {
				  location.href = (this.$route.path + '?v=1.05')
			}
		}

		if (!this.$route.params.id) {
			this.modelData.travelGroupCustomers = []
			this.modelData.travelGroupHotelInfos = []
			this.modelData.travelGroupFlightInfos = []
		}
		// get languageId from localStorage
		const customerLanguageId = this.$route.query.languageId
		if (customerLanguageId) { this.languageId = parseInt(customerLanguageId) } else { this.languageId = languageId }
		localStorage.setItem('languageId', this.languageId)
		this.changeLang(this.languageId)

		// get SaasApp from domain
		let url = window.location.hostname
		// console.log('url', url)
		this.getSaasAppDetail(url)

		this.loaderShow = true
		Promise.all([
			this.getTourReservationStatuses(),
			this.getLanguages(),
			this.getMealBoardTypes(),
			this.getMahramTypes(),
			this.getCustomerTitles(),
			this.getGenders(),
			this.getAirports(),
			this.getCountry()
			// this.getPassportTypes()
			// this.getGifts()
		]).finally(async () => {
			if (this.$route.query.tourId) {
				this.modelData.tourId = parseInt(this.$route.query.tourId)
				this.isTourHidden = true
				await this.getTourDetail()
			}
			this.loaderShow = false
			this.addCustomer()
		})

		// setTimeout(() => {
		// 	this.$v.$touch()
		// }, 1500)

		// setTimeout(() => {
		// 	console.log(this.$v.modelData.travelGroupCustomers.$each.$iter[0].customer.name.$error)
		// 	this.$v.modelData.travelGroupCustomers.$each.$iter[0].customer.name.$error = false
		// }, 3500)
		// this.modelData.travelGroupCustomers.map(item => {
		// })
	},
	computed: {
		...mapGetters('User', ['user']),
		totalAmount () {
			return this.modelData.totalAmount = this.modelData.travelGroupCustomers.reduce((acc, item) => {
				if (!item.amount) return acc + 0
				else return acc + item.amount
			}, 0)
		}

	},
	methods: {
		async handlePostCodeChange (item) {
			const customer = item.customer
			if (customer.postCode && customer.passportCountryId === 276 && customer.postCode.length > 4) {
				try {
					const { data } = await this.$http.get(`https://api.zippopotam.us/de/${customer.postCode}`)
					if (data.places && data.places.length > 0) {
						const placeName = data.places[0]['place name']
						item.customer.city = placeName || ''
					}
				} catch (error) {

				}
			}
		},
		checkedSameAddress () {
			if (this.sameAddress && this.modelData.travelGroupCustomers.length > 0) {
				const baseCustomer = this.modelData.travelGroupCustomers[0].customer
				this.modelData.travelGroupCustomers.map((cus, index) => {
					if (index > 0) {
						cus.customer.passportCountryId = baseCustomer.passportCountryId
						cus.customer.state = baseCustomer.state
						cus.customer.city = baseCustomer.city
						cus.customer.postCode = baseCustomer.postCode
						cus.customer.street = baseCustomer.street
						cus.customer.buildingNumber = baseCustomer.buildingNumber
					}
				})
			}
		},
		handleOnChangeCountry (item) {
			if (item.passportCountryId !== 276) {
				item.state = null
			}
		},
		async handleOnChange (e, item) {
			this.cities = []
			try {
				let query = {
					filter: {
						countryId: e.value
					},
					expand: {
						languageContents: {
							select: ['name', 'id'],
							filter: {
								languageId: {
									eq: this.languageId
								}
							}
						}
					}
				}
				query = buildQuery(query)

				const { data } = await this.$http.get('cities' + query)
				let cities = []
				data.value.map(item => {
					cities.push({ id: item.id, name: item.languageContents[0].name })
				})
				this.cities = [...cities]
			} catch (error) {

			}
		},
		changeLang (languageId) {
			var languageCode = 'tr'
			if (languageId === 7) languageCode = 'de'

			this.$i18n.locale = languageCode
			this.$moment.locale(languageCode)
		},
		async getSaasAppDetail (url) {
			try {
				const { data } = await this.$http.get(`WebSiteLicences/GetWebSiteInfoByUrl/${url}`)
				this.saasAppDetail = data
			} catch (error) {
				console.log(error)
			}
		},
		async setDealerId () {
			// eğer semerşah avrupa ise aşağıdaki kodlar çalışsın.
			this.modelData.travelGroupCustomers.map((item, i) => {
				if (window.location.origin.toLowerCase().indexOf('semersaheurope') > -1 ||
				window.location.origin.toLowerCase().indexOf('localhost') > -1) {
					let dealerId = null
					if (item.customer.passportCountryId == 578) dealerId = 4998213 // Norveç B1
					else if (item.customer.passportCountryId == 528) dealerId = 4998216 // Holanda B2 AMS
					else if (item.customer.passportCountryId == 826) dealerId = 4998213 // İngiltere B1
					else if (item.customer.passportCountryId == 56) dealerId = 4998230 // Belçika B2 BRU
					else if (item.customer.passportCountryId == 40) dealerId = 4998219 // Avusturya B4
					else if (item.customer.passportCountryId == 250) dealerId = 4998218 // Fransa B3
					else if (item.customer.passportCountryId == 756) dealerId = 4998219 // İsviçre B4
					else if (item.customer.passportCountryId == 616) dealerId = 4998222 // Polonya B7
					else if (item.customer.passportCountryId == 380) dealerId = 4998219 // İtalya B4
					else if (item.customer.passportCountryId == 208) dealerId = 4998213 // Danimarka B1
					else {
						let selectedState = this.states.find(x => x.name == item.customer.state)
						if (selectedState) {
							dealerId = selectedState.dealerId
						}
					}

					item.customer.dealerId = dealerId
					item.customer.country = this.countries.find(x => x.id == item.customer.passportCountryId).name
					item.dealerId = dealerId
					if (dealerId) { this.modelData.dealerId = dealerId }
				}
			})
		},
		handleWizardStepChanged (index) {
			let oldTab = this.wizard.find(f => f.activeconent)
			let oldIndex = this.wizard.indexOf(oldTab)
			let isError = false
			console.log('step')
			this.setMahramControl()
			this.togetherCustomers[1].visible = this.modelData.travelGroupCustomers.length > 1

			if (oldIndex < index) { // demekki sonraki adımlardan birine geçiyor doğrulama yap
				this.$v.$touch()
				this.modelData.travelGroupCustomers.map((item, i) => {
					if (index > 0) {
						// this.noBadControl(item)
						this.checkedSameAddress()
						if (
							this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.genderId.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.name.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.surname.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.gsm.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.email.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.passportNationalityId.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.passportCountryId.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.birthPlace.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.birthDate.$error ||
							// this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.passportNumber.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.passportIssueDate.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.passportExpiryDate.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.city.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.state.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.street.$error ||
              this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.buildingNumber.$error ||
			  this.$v.modelData.travelGroupCustomers.$each.$iter[i].customer.baseAirPort.$error
						) {
							isError = true
						}
					}
					if (index > 1) {
						if (this.$v.modelData.travelGroupCustomers.$each.$iter[i].tourPricePackageId.$error ||
							this.$v.modelData.travelGroupCustomers.$each.$iter[i].roomingDescription.$error ||
							this.$v.modelData.travelGroupCustomers.$each.$iter[i].flightDescription.$error
						) {
							isError = true
						}
					}
				})

				if (!isError) {
					this.wizard.map((x, i) => { x.activeconent = false })
					this.wizard[index].activeconent = true
					this.wizard[index].completeclass = true
					this.wizardIndex = index
				}
			} else {
				this.wizard.map((x, i) => { x.activeconent = false })
				this.wizard[index].activeconent = true
				this.wizard[index].completeclass = true
				this.wizardIndex = index
			}

			this.customerss = []
			this.customerss = this.modelData.travelGroupCustomers.map(item => {
				item.customer['@fullname'] = item.customer.name + ' ' + item.customer.surname
				console.log('seyma', item.customer['@fullname'])
				return item.customer
			})
		},
		diffInDay () {
			return (
				Math.floor(
					Math.abs(
						(new Date().getTime() - this.age.getTime()) /
            (24 * 60 * 60 * 1000)
					)
				)
			)
		},
		async getGifts () {
			try {
				let query = buildQuery({
					select: ['id', 'name'],
					filter: { isActive: true }
				})

				const { data } = await this.$http.get(`Gifts${query}`)
				if (data.value.length > 0) this.gifts = data.value
			} catch (error) { console.log(error) }
		},
		async getGenders () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=Gender&langId=${this.languageId}`)
				data.map((c) => { c.name = c.languageContents[0].name })
				this.genders = data
			} catch (err) { console.log(err) }
		},
		async getAirports () {
			try {
				var airportsList = [{ code: 'BER' }, { code: 'BRE' }, { code: 'CGN' }, { code: 'DUS' }, { code: 'FRA' }, { code: 'HAM' }, { code: 'HAJ' }, { code: 'MUC' }, { code: 'NUE' }, { code: 'STR' }, { code: 'VIE' }, { code: 'BSL' }, { code: 'LYS' }, { code: 'CDG' }, { code: 'BRU' }, { code: 'AMS' }, { code: 'CPH' }, { code: 'ASR' }, { code: 'IST' }, { code: 'ZRH' }, { code: 'RTM' }]
				let query = buildQuery({
					select: ['id', 'name', 'code'],
					filter: {
						or: airportsList
					}
				})
				const { data } = await this.$http.get(`Airports${query}`)
				data.value.map(item => item.name = '(' + item.code + ')-' + item.name)
				this.airports = data.value
				// this.airports = this.airports.slice(0, 3) // 3 airport just for test
			} catch (err) { console.log(err) }
		},
		async getCountry () {
			try {
				const {data} = await this.$http.get(`Countries/getCountryFromCache?langId=${this.languageId}`)
				data.map((item) => {
					try { item.name = item.languageContents[0].name } catch (err) { }
				})

				this.countries = data.sort((a, b) => (a.name > b.name) ? 1 : -1)
				let selectedCounries = [276, 528, 40, 56, 250, 752, 616, 380, 826, 208, 756, 578]
				this.countries2 = data.filter(x => selectedCounries.includes(x.id))
			} catch (err) { }
		},
		async getPassportTypes () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=PassportType&langId=${this.languageId}`)
				data.map((item) => {
					item.label = item.languageContents[0].name
				})
				this.passportTypes = data
			} catch (err) { }
		},
		setCateOnKeyPressed (v, trCus) {
			let expiryDate = moment(v)
			let finishDate = moment(this.selectedTour.finishDate)
			let diffDay = expiryDate.diff(finishDate, 'days') // 1
			if (diffDay < 180) {
				this.$toasted.info(this.$t('error.fill.expiryDate'), {duration: 15000})
			}
		},
		removeCustomer (index) {
			this.modelData.travelGroupCustomers.splice(index, 1)
		},
		addCustomer () {
			let newCustomer = {
				roomingDescription: null,
				flightDescription: null,
				customer: { baseAirPort: null, name: '', surname: '', gsm: '', email: '', passportCountryId: null, passportNationalityId: null, birthDate: null, birthPlace: '', passportNumber: '', passportIssueDate: null, passportExpiryDate: null, state: '', city: '', postCode: '', street: '', buildingNumber: '', genderId: null },
				mahramTypeId: null,
				mahram: {},
				'@normalPrice': null,
				'@mahramRequired': true,
				'@mahramTypeRequired': true,
				togetherCustomer: this.togetherCustomers[0],
				// dealerId: null,
				amount: null,
				discount: null,
				tourPricePackage: {},
				tourPricePackageId: null,
				noBed: false,
				giftIsSent: false
			}

			let url = window.location.hostname
			if (url == 'localhost') { newCustomer.customer = { baseAirPort: null, name: 'aaa', surname: 'aaa', gsm: '34234324', email: 'aaa@aaa.aaa', passportCountryId: 310, passportNationalityId: 310, birthDate: new Date(2020, 1, 1), birthPlace: 'A', passportNumber: 'A3343434', passportIssueDate: new Date(2020, 1, 1), passportExpiryDate: new Date(2025, 1, 1), state: 'a', city: 'a', postCode: 'aaa', street: 'aaa', buildingNumber: '444', genderId: 8 } }

			this.modelData.travelGroupCustomers.push(newCustomer)
			this.nextPrevious = true
		},

		addFromPassword () {
			this.$router.push({ name: 'app.user.crm.customers.customerpassportreading' })
		},
		async reset () {
			this.$router.push('/tourReservation/tourSales')
		},
		async getTourDetail () {
			try {
				// bu uçuş parkuru turdan gelmişse bunu kaldırıyoruz (aşağıda yenileri eklenecek)
				this.modelData.travelGroupFlightInfos = this.modelData.travelGroupFlightInfos.filter(function (item) {
					return !item.tourItineraryId
				})
				// bu otel parkuru turdan gelmişse bunu kaldırıyoruz (aşağıda yenileri eklenecek)
				this.modelData.travelGroupHotelInfos = []
				// tur seçilmemişse return
				if (!this.modelData.tourId) {
					return
				}
				const { data } = await this.$http.post(`Tours/GetTours/${this.modelData.tourId}`, {})

				data.data.map(item => {
					if (item.tourPricePackages) item.tourPricePackages = item.tourPricePackages.filter(x => !x.isDelete)
					if (item.tourHotelItineraries) item.tourHotelItineraries = item.tourHotelItineraries.filter(x => !x.isDelete)
					if (item.tourItineraries) item.tourItineraries = item.tourItineraries.filter(x => !x.isDelete)
					if (item.tourChildAges) 	item.tourChildAges = item.tourChildAges.filter(x => !x.isDelete)
					if (item.tourVisaTypes) item.tourVisaTypes = item.tourVisaTypes.filter(x => !x.isDelete)
					if (item.tour_TourExtras) item.tour_TourExtras = item.tour_TourExtras.filter(x => !x.isDelete)
				})

				this.modelData.companyId = data.data[0].ownerCompanyId
				this.selectedTour = data.data[0]
				this.tourName = this.selectedTour.name
				this.displayTourName = true
				this.selectedTour.tourPricePackages = this.selectedTour.tourPricePackages.filter(w => w.tourPriceType == 3)

				this.modelData.travelGroupFlightInfos = []
				this.modelData.tourHotelItineraries = []

				this.noBadAgeLimit = 0
				let url = window.location.hostname
				if (url.includes('semersaheurope')) this.noBadAgeLimit = 6
				else {
					try {
						this.noBadAgeLimit = this.selectedTour.tourChildAges.reduce((max, current) => {
							return current.childAge.max > max ? current.childAge.max : max
				  }, this.selectedTour.tourChildAges[0].childAge.max)
					} catch (error) { }
				}
				this.modelData.travelGroupCustomers.map(cus => {
					cus['@normalPrice'] = null
					cus.tourPricePackageId = null
					cus.amount = null
					cus.tourPricePackage = null
				})
				// gerekli evrakları çek
				// this.getRequiredDocuments()
			} catch (error) {
				console.log(error)
			}
		},
		async getMealBoardTypes () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=MealBoardType&langId=${this.languageId}`)
				data.map((item) => {
					item.name = item.languageContents[0].name
				})

				this.mealBoardTypes = data
			} catch (err) { }
		},
		async getCustomerTitles () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=CustomerTitle&langId=${this.languageId}`)
				data.map((item) => {
					item.name = item.languageContents[0].name
				})

				this.customerTitles = data
			} catch (err) { }
		},
		async getMahramTypes () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=MahramType&langId=${this.languageId}`)
				data.map((item) => {
					item.name = item.languageContents[0].name
				})

				this.mahramTypes = data
			} catch (err) { }
		},
		async getTourReservationStatuses () {
			try {
				const { data } = await this.$http.get(`AdminDatas/GetAdminDataFromCache?dataType=TourReservationStatus&langId=${this.languageId}`)
				data.map((item) => {
					item.name = item.languageContents[0].name
				})

				this.tourReservationStatuses = data
			} catch (err) { }
		},
		async getLanguages () {
			try {
				let query = buildQuery({
					select: ['id', 'name', 'code'],
					orderBy: `code asc`,
					filter: { isActive: true }
				})

				const { data } = await this.$http.get(`Languages${query}`)
				this.languages = data.value
				this.languages.map(m => { m.name = m.name + ' (' + m.code + ')' })
			} catch (error) { }
		},
		async handleTourSelected (selected) {
			this.modelData.tourId = selected.itemData.id
			this.loaderShow = true
			await this.getTourDetail()
			this.loaderShow = false
		},
		setMahramControl () {
			this.modelData.travelGroupCustomers.map(cus => {
				var today = new Date()
				let age = null
				console.log('22')
				cus.customer.birthDate = new Date(cus.customer.birthDate)
				console.log('33')
				if (cus.customer.birthDate) {
					age = today.getFullYear() - cus.customer.birthDate.getFullYear()
				}
				console.log('44')
				cus.customer['@birthDate'] = cus.customer.birthDate
				cus.customer['@age'] = age
				cus.customer.age = age
				console.log('0')

				if (!this.selectedTour.mahramControl) { // mahrem seçme gereği yoksa gizle
					cus['@mahramRequired'] = false
					cus['@mahramTypeRequired'] = false
				} else { // mahrem kontrolü gerekiyorsa
					if (age == null) {
						cus['@mahramRequired'] = true
						cus['@mahramTypeRequired'] = true
					} else if (age >= this.saasAppDetail.womenGroupAgeLimit && cus.customer.genderId === 9) { // 45 yaından büyük kadın
						cus['@mahramRequired'] = false
						cus['@mahramTypeRequired'] = true
						cus.mahram = {}
						cus.mahramTypeId = 80
					} else if (age < this.saasAppDetail.manMahramLimit) { // 18 yaşından küçük
						cus['@mahramRequired'] = true
						cus['@mahramTypeRequired'] = true
					} else if (age < this.saasAppDetail.womenGroupAgeLimit && cus.customer.genderId === 9) { // 45 yaından küçük kadın
						console.log('1')
						cus['@mahramRequired'] = true
						cus['@mahramTypeRequired'] = true
					} else { // mahram gerekmiyor
						console.log('s')
						cus['@mahramRequired'] = false
						cus['@mahramTypeRequired'] = false
						cus.mahramTypeId = null
						cus.mahram = {}
					}
				}
			})

			this.keyIndex++
			this.$forceUpdate()
		},
		handleMahramTypeChanged (selected, item) {
			item.mahramTypeId = selected
			if (item.mahramTypeId === 87) { // mahremsiz
				item['@mahramRequired'] = false
				item.mahram = {}
			} else {
				item['@mahramRequired'] = true
			}
		},
		handleDealerChanged (selected) {
			// this.modelData.travelGroupCustomers.map(m => m.dealerId = selected)
		},
		getCustemerInfo (item) {
			if (!item) return ''
			else if (item.surname) return item.name + ' ' + item.surname
			else return item.name
		},
		handleInvoceCustomerSelected (data) {
			this.modelData.invoiceCustomer = data.itemData
		},
		async handlePackageChanged (selected, cus) {
			this.showInfo = true
			if (!selected) {
				cus.tourPricePackage = null
				cus.tourPricePackageId = null
				cus['@normalPrice'] = null
				cus.amount = null
				return
			}
			cus.tourPricePackage = selected
			cus.tourPricePackageId = selected.id
			cus['@normalPrice'] = selected.price

			if (this.noBadControl(cus)) {
				cus.noBed = true
			}

			this.calculatePackagePrice()

			this.keyIndex++
			this.$forceUpdate()
		},
		async handleNoBedChange (selected, cus) {
			if (!cus.tourPricePackageId) {
				return
			}
			cus['@normalPrice'] = selected.price

			this.calculatePackagePrice()

			this.keyIndex++
		},
		noBadControl (item) {
			item.customer['@age'] = this.calculateAge(item.customer.birthDate)
			if (this.noBadAgeLimit) {
				if (item) {
					if ((item.customer['@age'] || item.customer['@age'] === 0) && (item.customer['@age'] < this.noBadAgeLimit)) {
						return true
					}
					return false
				}
			}
		},
		calculateAge (birthDate) {
			// tur bitiş tarihine göre yaş hesaplıyoruz, bitiş tarihi boş ise tur başlangıca, o da boşsa bugune bakıyor
			var today = new Date()
			var checkDate = this.selectedTour.finishDate ? this.selectedTour.finishDate : (this.selectedTour.startDate ? this.selectedTour.startDate : today)
			var birthDateC = new Date(birthDate)
			checkDate = new Date(checkDate)
			checkDate = new Date(checkDate.getFullYear(), checkDate.getMonth(), checkDate.getDate()) // saatsiz tarih
			birthDateC = new Date(birthDateC.getFullYear(), birthDateC.getMonth(), birthDateC.getDate())// saatsiz tarih
			let yearDiff = checkDate.getFullYear() - birthDateC.getFullYear()
			let monthDiff = checkDate.getMonth() - birthDateC.getMonth()
			let dayDiff = checkDate.getDate() - birthDateC.getDate()
			var age = yearDiff
			if ((monthDiff == 0 && dayDiff < 0) || (monthDiff < 0)) { age = yearDiff - 1 }
			return age
		},		// paket fiyatını hesapla
		async calculatePackagePrice () {
			try {
				const { data } = await this.$http.post(`TravelGroups/CalculateAmount?withDiscount=false`, { ...this.modelData })
				data.travelGroupCustomers.map((m, i) => {
					// hesaplanan fiyatları dönüyoruz.
					if (m.amount) {
						// eğer fiyat hesaplanabilmişse bu müşteriyi modelde bulup fiyatını yazıyoruz
						let customer = this.modelData.travelGroupCustomers[i] // .find(f => f.customerId === m.customerId)
						customer['@normalPrice'] = m.amount
						if (customer.discount) { // indirim girilmişse indirimi düş
							customer.amount = parseFloat(m.amount) + customer.discount
						} else {
							customer.amount = parseFloat(m.amount)
						}
					}
					this.modelData.travelGroupCustomers[i].specialArea1 = this.selectedTour.currency.symbol
				})
				this.keyIndex++
				this.$forceUpdate()
			} catch (err) { }
		},
		async create () {
			if (!(!this.$v.$touch() && !this.$v.$error)) {
				this.$toasted.global.error({ message: this.$t('error.fill.allFields') })
				return
			}

			if (this.modelData.travelGroupCustomers.length < 1) {
				this.$toasted.global.error({ message: this.$t('operation.tour.error.mustBe1Customer') })
				return
			}
			if (!this.isReadKvkk) {
				this.$toasted.global.error({ message: this.$t('kvkktext.mustBeRead') })
				return
			}

			await this.setDealerId()
			await this.checkedSameAddress()

			let newObjet = this.deepClone(this.modelData)
			newObjet.travelGroupCustomers.map(x => x.specialArea1 = null)
			let sameRoom = newObjet.travelGroupCustomers[0].togetherCustomer.name == 'all'
			// seçilen bayiyi alt müşterilere ayarlıyrouz
			newObjet.travelGroupCustomers.map(m => {
				m.tourId = newObjet.tourId
				// tarih kayıtta hata verdiği için bu kısm kaldırıldı
				try { m.customer.birthDate.setHours(12) } catch (error) {}
				try { m.customer.passportExpiryDate.setHours(12) } catch (error) {}
				try { m.customer.passportIssueDate.setHours(12) } catch (error) {}

				if (sameRoom) { // hepsi aynı odada kalacağı için hepsine ilk müşteriyi set ediyoruz.
					m.togetherCustomer = newObjet.travelGroupCustomers[0].customer
				} else {
					m.togetherCustomer = null
				}
			})
			if (!this.loaderShow) { // !this.$v.$touch() && !this.$v.$error
				this.loaderShow = true
				try {
					await this.$http.post('TravelGroups/CustomerCreateReservation', newObjet)
					// log
					const logObject = {
						data: JSON.stringify(newObjet),
						queryTypeId: '232', // Insert
						description: 'Online Rezervasyon Kaydı',
						operationTypeId: '230' // Tour_Reservation
					}
					this.$http.post('exceptionlogs/CreateEventLogs', logObject)
					this.$toasted.global.success({ message: this.$t('reservation.result.messsage') })
					// this.$router.push('/tourReservation/tourSales')
					// location.reload()
					location.href = redirectPath
				} catch (err) {
					this.$toasted.global.error({ message: this.$t('error.error_unknown') })
				}
				this.loaderShow = false
			}
		}
	},
	watch: {

	},
	validations: {
		modelData: {
			// isReadKvkk: {required},
			companyId: { required },
			tourReservationStatusId: { required },
			tourId: { required },
			travelGroupFlightInfos: {},
			travelGroupCustomers: {
				$each: {
					tourPricePackageId: { required },
					specialArea2: { required },
					flightDescription: { required },
					roomingDescription: {
						required: requiredIf(function (data) {
							return data.togetherCustomer.name == 'other'
						})
					},
					customer: {
						state: {
							required: requiredIf(function (data) {
								return data.passportCountryId === 276
							})
						},
						genderId: { required },
						name: { required },
						surname: { required },
						gsm: { required },
						email: { required, email },
						city: { required },
						postCode: { required },
						street: { required },
						buildingNumber: { required },
						// tckn
						passportNationalityId: { required },
						birthPlace: { required },
						birthDate: { required },
						passportNumber: {
							required
							// checked (val, vm) {
							// 	const regex = /^[A-Z]\s*[A-Z0-9]{6,9}$/
							// 	const result = regex.test(val)
							// 	return result
							// }
						},
						// passportTypeId: { required },
						passportCountryId: { required },
						// passportIssuePlace: { required },
						passportIssueDate: { required },
						passportExpiryDate: { required },
						baseAirPort: { required }
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/app/user/operation/tour/sale/sale-create/SaleCreate.js